import { Component } from '@angular/core';
import {IonicPage, LoadingController, NavController, NavParams, Platform, ViewController} from 'ionic-angular';
import {ServiceProvider} from "../../providers/service/service";


@Component({
  selector: 'page-get-new-admissions',
  templateUrl: 'get-new-admissions.html',
})
export class GetNewAdmissionsPage {

  AdminReport: any;

  constructor(public navCtrl: NavController,
              public service: ServiceProvider,
              public viewCtrl: ViewController,
              public loadingCtrl: LoadingController,
              public platform : Platform,
              public navParams: NavParams) {

    this.platform.ready().then(() => {
      this.loadvalues();
    });

  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad GetNewAdmissionsPage');
  }


  loadvalues() {

    let loading = this.loadingCtrl.create({
      content: 'Please wait...'
    });

    loading.present();

    this.AdminReport = [];

    this.service.httpcall('app_web_service/get_New_admissions_report?').subscribe(data => {

      this.AdminReport = data;
      console.log('AdminReport',this.AdminReport);
      loading.dismiss();
    })
  }

  doRefresh(refresher) {
    console.log('Begin async operation', refresher);

    this.loadvalues();

    setTimeout(() => {
      console.log('Async operation has ended');

      refresher.complete();
    }, 2000);
  }

  backBTN() {
    this.viewCtrl.dismiss();
  }

}



// WEBPACK FOOTER //
// ./src/pages/get-new-admissions/get-new-admissions.ts